
<div class="dialog-overlay">
    <mat-card class="dialog-card" [ngClass]="currentTheme">
        <div class="dialog-header">
            <h2 class="dialog-title">Assign Vehicle & Trailer</h2>
            <button mat-icon-button class="close-button" (click)="onCancelClick()">
                <mat-icon>close</mat-icon>
            </button>
        </div>

        <div class="dialog-content">
            <div class="assignment-container">
                <div class="assignment-section">
                    <h3 class="section-title">Vehicle</h3>

                    <div class="search-container">
                        <div class="search-input-wrapper">
                            <mat-icon class="search-icon">directions_car</mat-icon>
                            <mat-form-field class="search-input" appearance="outline">
                                <mat-label>Search Vehicle</mat-label>
                                <input matInput [formControl]="searchControl"
                                       placeholder="Search Vehicle...">
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="list-container">
                        <div class="list-content" *ngIf="filteredVehicleOptions.length > 0; else noVehicles">
                            <div class="list-item" *ngFor="let option of filteredVehicleOptions">
                                <span class="item-text">
                                    {{ option.regNumber }}
                                    <small *ngIf="option.source === 'lookup'"> ({{ option.carrierName }} · {{ option.provider }})</small>
                                </span>
                                <button mat-raised-button color="primary"
                                        class="assign-button"
                                        [disabled]="isLoading"
                                        (click)="assignVehicle(option)">
                                    Assign
                                </button>
                            </div>
                        </div>
                        <ng-template #noVehicles>
                            <div class="empty-state">
                                <p class="empty-text">No vehicles available</p>
                            </div>
                        </ng-template>
                    </div>

                    <div class="assigned-display" *ngIf="selectedVehicleOption">
                        <div class="assigned-item">
                            <mat-icon class="assigned-icon">check_circle</mat-icon>
                            <span class="assigned-text">
                                Assigned Vehicle: {{ selectedVehicleOption.regNumber }}
                                <small *ngIf="selectedVehicleOption.source === 'lookup'">(lookup)</small>
                            </span>
                            <button mat-icon-button class="remove-button" (click)="removeVehicle()">
                                <mat-icon>close</mat-icon>
                            </button>
                        </div>
                    </div>
                </div>

                <div class="assignment-section">
                    <h3 class="section-title">Trailer</h3>

                    <div class="search-container">
                        <div class="search-input-wrapper">
                            <mat-icon class="search-icon">local_shipping</mat-icon>
                            <mat-form-field class="search-input" appearance="outline">
                                <mat-label>Trailer Plate Number</mat-label>
                                <input matInput [formControl]="trailerSearchControl"
                                       placeholder="Enter trailer plate number..."
                                       (input)="assignTrailer(trailerSearchControl.value)"
                                       (change)="onTrailerInputChange($event)">
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="assigned-display" *ngIf="selectedTrailer">
                        <div class="assigned-item">
                            <mat-icon class="assigned-icon">check_circle</mat-icon>
                            <span class="assigned-text">Assigned Trailer: {{ selectedTrailer }}</span>
                            <button mat-icon-button class="remove-button" (click)="removeTrailer()">
                                <mat-icon>close</mat-icon>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="dialog-footer">
            <button mat-stroked-button class="cancel-button" (click)="onCancelClick()">
                Cancel
            </button>
            <button mat-raised-button color="accent" class="add-vehicle-button" (click)="onAddVehicleClick()">
                Add New
            </button>
            <button mat-raised-button color="primary" class="save-button" (click)="onSaveClick()">
                Save
            </button>
        </div>
    </mat-card>
</div>

